<template>

  <div class="col-inner p-3 bg-white rounded">
    <form>
      <div class="mb-3">
        <h5 class="danger_text fw-bold-600 font-s22">{{ trans('auctions.filters.name') }}</h5>
        <input
          type="text"
          class="form-control"
          id="model"
          aria-describedby="Model"
          :placeholder="trans('auctions.filters.name_placeholder')"
          v-model="modelValue.model"
        >
      </div>
      <div class="mb-3">
        <h5 class="danger_text fw-bold-600 font-s22">{{ trans('auctions.filters.fuel') }}</h5>
        <div v-for="fuel in fuels" class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            :name="fuel.name"
            :id="fuel.id"
            :value="fuel.name"
            :checked="this.modelValue.fuels.includes(fuel.name)"
            @change="setFuel(fuel.name)"
          >
          <label class="form-check-label fw-bold-500 back-text font-s14" :for="fuel.id">
            {{ fuel.name }}
          </label>
        </div>
      </div>
      <div class="mb-3">
        <h5 class="danger_text fw-bold-600 font-s22">{{ trans('auctions.filters.gearbox') }}</h5>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="gearbox"
            id="gearbox"
            value="AUTOMAT"
            v-model="modelValue.gearbox"
          >
          <label class="form-check-label fw-bold-500 back-text font-s14" for="gearbox">
            {{ trans('auctions.filters.automate') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="gearbox"
            id="gearbox1"
            value="MANUELL"
            v-model="modelValue.gearbox"
          >
          <label class="form-check-label fw-bold-500 back-text font-s14" for="gearbox1">
            {{ trans('auctions.filters.manual') }}
          </label>
        </div>
      </div>
      <div class="mb-3">
        <h5 class="danger_text fw-bold-600 font-s22">{{ trans('auctions.filters.tax_group') }}</h5>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="tax_group"
            id="tax_group"
            value="varebil"
            v-model="modelValue.tax_group"
          >
          <label class="form-check-label fw-bold-500 back-text font-s14" for="tax_group">
            {{ trans('auctions.filters.varebil') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="tax_group"
            id="tax_group1"
            value="personbil"
            v-model="modelValue.tax_group"
          >
          <label class="form-check-label fw-bold-500 back-text font-s14" for="tax_group1">
            {{ trans('auctions.filters.personbil') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="tax_group"
            id="tax_group2"
            value="annet"
            v-model="modelValue.tax_group"
          >
          <label class="form-check-label fw-bold-500 back-text font-s14" for="tax_group2">
            {{ trans('auctions.filters.annet') }}
          </label>
        </div>
      </div>
      <div class="mb-3">
        <h5 class="danger_text fw-bold-600 font-s22">{{ trans('auctions.filters.driving') }}</h5>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="driving"
            id="driving"
            value="1"
            v-model="modelValue.driwing"
          >
          <label class="form-check-label fw-bold-500 back-text font-s14" for="driving">
            {{ trans('auctions.filters.2wd') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="driwing"
            id="driwing1"
            value="2"
            v-model="modelValue.driwing"
          >
          <label class="form-check-label fw-bold-500 back-text font-s14" for="driwing1">
            {{ trans('auctions.filters.4wd') }}
          </label>
        </div>
      </div>
      <div class="mb-3">
        <h5 class="danger_text fw-bold-600 font-s22"> {{ trans('auctions.filters.year') }}</h5>
        <div class="input-group mb-2">
          <input
            type="text"
            class="form-control"
            id="year_start"
            aria-describedby="Fra"
            placeholder="Fra"
            v-model="modelValue.year_start"
          >
        </div>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="year_end"
            aria-describedby="Til"
            placeholder="Til"
            v-model="modelValue.year_end"
          >
        </div>
      </div>
      <div class="d-xxl-flex justify-content-around filter-button-group gap-2" role="group"
           aria-label="Basic example">
        <button type="button"
                class="border-0 fw-bold-600 text-center btn-lg btn-primary extra-rounded dark-bg font-s20"
                @click="filterReset()"
        >
          {{ trans('auctions.filters.reset') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  props: ['modelValue', 'fuels'],
  emits: ['update:modelValue', 'reset'],
  mounted() {

  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    filterReset() {
      this.$emit('reset', '')
    },
    setFuel(fuelCode) {
      if (this.modelValue.fuels.includes(fuelCode)) {
        for (let i = 0; i <= this.modelValue.fuels.length; i++) {
          if (this.modelValue.fuels[i] === fuelCode) {

            this.modelValue.fuels.splice(i, 1)
          }
        }
      } else {
        this.modelValue.fuels.push(fuelCode)
      }
    }
  }
}
</script>
<style>

</style>
